// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"Daa-z"};